/**
 * PURPOSE: represents the different feature flags as an enum
 */
export enum FeatureFlagEnum {
  // NOTE: add feature flag names here in the form
  EXAMPLE_FEATURE_FLAG = "example-feature-flag",

  STATE_PARTNER_ENABLED_FEATURE_FLAG = "partner-state-active"
}
